import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'ProductCveList' })({
    content: {
        marginTop: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 24
    },
    spinner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 36,
        paddingBottom: 36
    }
});
